import {
  InvoiceTaskActivity,
  PaymentTaskActivity,
  PurchaseOrderActivity,
  PurchaseOrderContractTaskActivity, QuotationTaskActivity,
  SalesOrderActivity, SalesOrderContractTaskActivity
} from '@/hooks/api/models';
import { dateTimeFormat } from '@/utils';

type Props = {
  d: PurchaseOrderActivity | PurchaseOrderContractTaskActivity | PaymentTaskActivity | SalesOrderActivity | QuotationTaskActivity | SalesOrderContractTaskActivity | InvoiceTaskActivity;
};
export const ActivityRow = ({ d }: Props) => {
  return (
    <div className="timeline-block mb-3">
      <span className="timeline-step">
        {d.user ? (
          <img src={d.user.user_account.icon_file_url} className="avatar avatar-xs rounded-circle" />
        ) : (
          <i className="far fa-lightbulb text-primary"></i>
        )}
      </span>
      <div className="timeline-content">
        <h6 className="text-dark text-sm font-weight-bold mb-0">{d.content}</h6>
        <p className="text-secondary font-weight-bold text-xs mt-1 mb-0">
          by {d.user ? d.user.user_account.name : 'NODE'} {dateTimeFormat({ date: d.created_at })}
        </p>
      </div>
    </div>
  );
};
